<template>
  <div class="footer">

    <div class="tt-uc d-f jc-c">
      <p class="grey">© 2022</p>
    </div>

    <div class="text-block">
        
      <div class="row lt">
        <!-- <div><a href="https://formation.network" target="_blank" class="link">Formation.network <span class="desc">Debate Platform</span></a></div>
        <div><a href="https://algorhythm.world" target="_blank" class="link">Algorhythm.world <span class="desc">Music Platform</span></a></div>
        <div><a href="https://revir.us" target="_blank" class="link">Revir.us <span class="desc">Apparel Brand</span></a></div> -->

        <!-- <div>If you’re interested in any form of collaboration, please send us an email and we’ll get back shortly.</div> -->

        <!-- <div>Open for business. <br>Feel free to get in touch in any of our channels.</div> -->
        <div>Open for business.<br>Please feel free to contact us for any kind of inquiries.</div>
        
        <!-- <div>Open for business. <br>Based in Stockholm, Sweden but open for remote work as well.</div> -->

      </div>

      <div class="row rt m-top m-bottom">
        <a href="mailto:niklaz@mesh-in.com" target="_blank" class="link">Email</a>
        <a href="https://www.instagram.com/mesh_innovation/" target="_blank" class="link">Instagram</a>
        <a href="https://www.linkedin.com/company/mesh-innovation/" target="_blank" class="link">Linked In</a>
      </div>

    </div>

    <!-- <div class="tt-uc d-f jc-c pad-m">
      <p class="grey">© 2022</p>
    </div> -->
    <router-link to="/">
      <LogoAni/>
    </router-link>

  </div>
</template>

<script>
import LogoAni from '@/components/LogoAni.vue'

export default {
  name: 'Footer',
  components: {
    LogoAni
  },
  data() {
    return {
      time: ''
    }
  },
  mounted() {
    this.startTime()
  },
  methods: {

    startTime() {
      var dt = new Date();
      dt.setTime(dt.getTime() + (60 * 60 * 2000));
      var h = dt.getUTCHours();       // Use UTC methods to get time
      var m = dt.getUTCMinutes();
      var s = dt.getUTCSeconds();
      h = this.checkTime(h)
      m = this.checkTime(m)
      s = this.checkTime(s)
      this.time = h + ":" + m + ":" + s
      setTimeout(this.startTime, 500)
    },
    checkTime(i) {
      if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
      return i;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";
@import "../scss/_classes.scss";

</style>
